<template>
  <span>
    Welcome to Smartbooks, enjoy your
    <strong>FREE TRIAL</strong> until
    <strong>{{ eventLog.trialPeriodEnd | dateToHuman }}</strong>
  </span>
</template>
<script>
import { dateToHuman } from '@/helpers/helpers';
export default {
  name: 'recentActivityTableDescriptionUserCreated',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  },
  filters: { dateToHuman }
}
</script>
